import { Skeleton, CardContent, CardHeader, Grid, Button, Paper, Divider } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';


import { Box, Typography, useTheme, Avatar } from "@mui/material";
import { tokens } from '../../theme';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useState, useEffect } from 'react';
import FormKitPage from './form-kit';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

import { djangoApi } from "../../utils/axios/axios.utils";
import { useDispatch, useSelector } from "react-redux";
import { selectProducts, getKitsBySeller } from "../../store/products/products.selector";
import { setProducts, setSellersKits, updateSellersKitsIsFailureChanged } from "../../store/products/products.action";
import { selectCurrentUser } from "../../store/user/user.selector";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import TablesKitPage from './table-kits';

import ShowProductsPage from './show-products';
import NotaPromiPage from './nota-promiss';
import KitTableSkeleton from './table-kits-skeleton';
import ResumeSectionKit from './resume-section-kit';
import ObservacaoKitPage from './info-section-observacao';
import CreateNf from './resume-section-kit-nf';
import ResumeInfoBox from './resume-seller-prods';
import { comissionHandler } from '../../utils/comission-handler';
import SellerWarrantiesAccordion from '../../components/warranties/SellerWarrantiesAccordion';
import SellerKitOrdersAccordion from '../../components/kits/SellerKitOrdersAccordion';


import SellerSoldProductsAccordion from '../../components/warranties/SellerSoldProductsAccordion';


const DataSectionSeller = ({ seller, isLoadingKit, setIsLoadingKit }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [openForm, setOpenForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSavingData, setIsSavingData] = useState(false);
    const MySwal = withReactContent(Swal);

    const [valuesToSave, setValuesToSave] = useState([]);
    const [initialDate, setInitialDate] = useState(null);



    const productsData = useSelector(selectProducts)
    const sellersKits = useSelector(getKitsBySeller(seller.id))
    const dispatch = useDispatch()

    const user = useSelector(selectCurrentUser);

    const [open, setOpen] = useState(false);
    const [showModalprods, setShowModalprods] = useState([])

    const [openNotaPromi, setOpenNotaPromi] = useState(false);
    const [dataPromiss, seTdataPromiss] = useState({});

    const [formType, setFormType] = useState(null);
    const [dataToEdit, setDataToEdit] = useState({});

    const [isActiveKit, setIsActiveKit] = useState(false);
    const [failureToPay, setFailureToPay] = useState(false);

    const [updatedKit, setUpdatedKit] = useState({});

    const [biggestValueKit, setBiggestValueKit] = useState(0);
    const [biggestValueKitProds, setBiggestValueKitProds] = useState(0);
    const [minValueKitProds, setMinValueKitProds] = useState(0);
    const [avgKitValues, setAvgKitValues] = useState(0);
    const [avgValues, setAvgValues] = useState(0);
    const [totalSoldProds, setTotalSoldProds] = useState(0);
    const [totalSoldProdsValue, setTotalSoldProdsValue] = useState(0);
    const [avgProductsPerKitLast10Months, setAvgProductsPerKitLast10Months] = useState(0);
    const [totalProductsSentLast10Months, setTotalProductsSentLast10Months] = useState(0);

    const [totalComissionValue, setTotalComissionValue] = useState(0);
    const [lastMonthsComissionValue, setLastMonthsComissionValue] = useState(0);

    const [valueForResume, setValueForResume] = useState(0);
    const [valueForComission, setValueForComission] = useState(0);
    const [valueForComissionVeludos, setValueForComissionVeludos] = useState(0);
    const [valueForComissionSacolas, setValueForComissionSacolas] = useState(0);

    const [paymentToPitaya, setPaymentToPitaya] = useState([]);
    const [nfExist, setNfExist] = useState(null);
    const [nfExistProd, setNfExistProd] = useState(null);

    const [dataCheckPayment, setDataCheckPayment] = useState({});

    const [caseType, setCaseType] = useState('');

    const [isDirty, setIsDirty] = useState(false);


    const dataToGrid = [
        { title: 'Média Vendas 12m', value: (isLoadingKit || isLoading) ? <Skeleton variant="text" width={80} /> : avgValues },
        { title: 'Maior Venda 12m', value: (isLoadingKit || isLoading) ? <Skeleton variant="text" width={80} /> : biggestValueKitProds },
        { title: 'Menor Venda 12m', value: (isLoadingKit || isLoading) ? <Skeleton variant="text" width={80} /> : minValueKitProds },
        { title: 'Produtos Enviados 12m', value: (isLoadingKit || isLoading) ? <Skeleton variant="text" width={80} /> : totalProductsSentLast10Months },
        { title: 'Média prod./Maleta 12m', value: (isLoadingKit || isLoading) ? <Skeleton variant="text" width={80} /> : avgProductsPerKitLast10Months },
        { title: 'Comissões 12m', value: (isLoadingKit || isLoading) ? <Skeleton variant="text" width={80} /> : lastMonthsComissionValue },
        { title: 'R$ Médio Maletas 12m', value: (isLoadingKit || isLoading) ? <Skeleton variant="text" width={80} /> : avgKitValues },
    ];

    const formatNumber = (data) => {
        if (!data) {
            return " - "
        }
        return data.toLocaleString(
            "pt-br",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        )
    }

    const formatInteger = (data) => {
        if (!data) {
            return " - ";
        }

        return data.toLocaleString("pt-br", {
            maximumFractionDigits: 0
        });
    };

    const isRealKitProduct = (product) => {
        const ignoredContentTypes = ["embalagem", "color"];

        if (!product) return false;
        if (product.product_id === "-") return false;
        if (ignoredContentTypes.includes(product.content_type)) return false;

        return true;
    };

    const getDateMonthsAgo = (months) => {
        const date = new Date();
        date.setMonth(date.getMonth() - months);
        date.setHours(0, 0, 0, 0);

        return date;
    };


    useEffect(() => {
        if (sellersKits?.kits) {
            const { kits } = sellersKits;

            const twelveMonthsAgo = getDateMonthsAgo(12);

            const kitsLast12Months = kits.filter((kit) => {
                if (!kit?.created_at) return false;

                const kitDate = new Date(kit.created_at);

                if (Number.isNaN(kitDate.getTime())) return false;

                return kitDate >= twelveMonthsAgo;
            });

            const closedKitsLast12Months = kitsLast12Months.filter((kit) => kit.is_active === false);

            const kitsLast12MonthsForProducts = kitsLast12Months;

            const totalProductsSentLast12 = kitsLast12MonthsForProducts.reduce((kitAcc, kit) => {
                const kitProductsTotal = kit.kit_products
                    ?.filter(isRealKitProduct)
                    ?.reduce((prodAcc, curr) => {
                        return prodAcc + Number(curr?.quantity || 0);
                    }, 0) || 0;

                return kitAcc + kitProductsTotal;
            }, 0);

            const avgProductsPerKitLast12 = kitsLast12MonthsForProducts.length > 0
                ? Math.ceil(totalProductsSentLast12 / kitsLast12MonthsForProducts.length)
                : 0;

            setTotalProductsSentLast10Months(
                totalProductsSentLast12 > 0 ? formatInteger(totalProductsSentLast12) : " - "
            );

            setAvgProductsPerKitLast10Months(
                kitsLast12MonthsForProducts.length > 0 ? `${formatInteger(avgProductsPerKitLast12)} un.` : " - "
            );

            const totalByKit = closedKitsLast12Months.map((kit) => {
                const totalByKit = kit.kit_products.reduce((acc, curr) => acc += ((curr.quantity - curr.quantity_returned) * curr.sell_price), 0)
                const totalProdsValue = kit.kit_products.reduce((acc, curr) => acc += ((curr.quantity * curr.sell_price)), 0)
                const totalByKitSoldProds = kit.kit_products.reduce((acc, curr) => acc += (curr.quantity - curr.quantity_returned), 0)
                return ({
                    kit: kit.kit_number,
                    total: totalByKit,
                    soldProds: totalByKitSoldProds,
                    totalProdsValue: totalProdsValue
                })
            })


            const totalByKitComissionFocus = closedKitsLast12Months.map((kit) => {
                // console.log('kit here: ', kit)
                const totalByKit = kit.kit_products.filter((model) => model.content_type !== 'embalagem').reduce((acc, curr) => acc += ((curr.quantity - curr.quantity_returned) * curr.sell_price), 0)
                // const totalProdsValue = kit.kit_products.reduce((acc, curr) => acc += ((curr.quantity * curr.sell_price)), 0)
                // const totalByKitSoldProds = kit.kit_products.reduce((acc, curr) => acc += (curr.quantity - curr.quantity_returned), 0)
                return ({
                    kit: kit.kit_number,
                    date_kit: kit.created_at,
                    total: totalByKit,
                    comission: comissionHandler(totalByKit)
                })
            })

            const totalComissionAllTime = totalByKitComissionFocus.reduce((acc, curr) => acc += curr.comission, 0)
            const totalComissionAllTimeFormated = `R$ ${formatNumber(totalComissionAllTime)}`
            setTotalComissionValue(totalComissionAllTimeFormated)

            const calculateTotalComissionLast12Months = (totalByKitComissionFocus, formatNumber) => {
                // 1. Calcular a data de 12 meses atrás a partir da data atual
                const twelveMonthsAgo = new Date();
                twelveMonthsAgo.setFullYear(twelveMonthsAgo.getFullYear() - 1);
                // Para garantir que a comparação seja feita a partir do início do dia de 12 meses atrás
                twelveMonthsAgo.setHours(0, 0, 0, 0);

                // 2. Filtrar os kits para incluir apenas os dos últimos 12 meses
                const filteredComissions = totalByKitComissionFocus.filter((item) => {
                    const itemDate = new Date(item.date_kit); // item.date_kit já está no formato "YYYY-MM-DD"
                    return itemDate >= twelveMonthsAgo;
                });

                // 3. Somar as comissões dos kits filtrados
                const totalComissionLast12Months = filteredComissions.reduce((acc, curr) => acc += curr.comission, 0);

                // 4. Formatar o valor
                const totalComissionLast12MonthsFormated = `R$ ${formatNumber(totalComissionLast12Months)}`;

                return totalComissionLast12MonthsFormated;
            };
            const lastComiValues = calculateTotalComissionLast12Months(totalByKitComissionFocus, formatNumber)
            setLastMonthsComissionValue(lastComiValues)

            // maior venda
            const kitWithHighestTotal = totalByKit.reduce((max, kit) => kit.totalProdsValue > max.totalProdsValue ? kit : max, totalByKit[0]);
            const formatedValue = `R$ ${formatNumber(kitWithHighestTotal?.totalProdsValue)}`
            setBiggestValueKit(formatedValue)

            const calculateAverageKitPrice = (totalByKit) => {
                if (!totalByKit || totalByKit.length === 0) {
                    return "R$ 0,00"; // Retorna R$ 0,00 se o array estiver vazio ou nulo
                }

                // Soma todos os valores 'total' das maletas
                const totalSumOfKits = totalByKit.reduce((sum, kit) => sum + kit.totalProdsValue, 0);

                // Calcula a média dividindo a soma pelo número de maletas
                const averagePrice = totalSumOfKits / totalByKit.length;

                // Retorna o valor formatado
                return `R$ ${formatNumber(averagePrice)}`;
            };
            const avgKitValue = calculateAverageKitPrice(totalByKit)
            setAvgKitValues(avgKitValue)


            // maior maleta
            const kitWithHighestTotalValue = totalByKit.reduce((max, kit) => kit.total > max.total ? kit : max, totalByKit[0]);
            const formatedValueProds = `R$ ${formatNumber(kitWithHighestTotalValue?.total)}`
            setBiggestValueKitProds(formatedValueProds)

            // menor maleta
            const kitWithMinTotalValue = totalByKit.reduce((max, kit) => kit.total < max.total ? kit : max, totalByKit[0]);
            const formatedMinValueProds = `R$ ${formatNumber(kitWithMinTotalValue?.total)}`
            setMinValueKitProds(formatedMinValueProds)

            // Média de vendas
            const calculateAverageSales = (totalByKit) => {
                if (!totalByKit || totalByKit.length === 0) {
                    return "R$ 0,00"; // Retorna R$ 0,00 ou outro valor padrão se o array estiver vazio ou nulo
                }

                const totalSum = totalByKit.reduce((sum, kit) => sum + kit.total, 0);
                const average = totalSum / totalByKit.length;

                return `R$ ${formatNumber(average)}`;
            };
            const totalAvgValue = calculateAverageSales(totalByKit)
            setAvgValues(totalAvgValue)

            // total de produtos vendidos
            const totalprodsSoldUntilNow = totalByKit.reduce((acc, curr) => acc += curr.soldProds, 0)
            const formatProd = totalprodsSoldUntilNow > 0 ? totalprodsSoldUntilNow : ' - '
            setTotalSoldProds(formatProd)

            // total em vendas
            const totalVendasValue = totalByKit.reduce((acc, curr) => acc += curr.total, 0)
            const formatedVendasValue = `R$ ${formatNumber(totalVendasValue)}`
            setTotalSoldProdsValue(formatedVendasValue)
        }
    }, [sellersKits]);


    const isCreatingKitWithoutCase =
        formType === 'Criando' &&
        valuesToSave?.length > 0 &&
        !caseType;

    const getProductsData = async () => {
        setIsLoading(true)
        try {
            await djangoApi
                .get("products/register_prods/get_all_prods/", {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    const { dados } = res.data;
                    dispatch(setProducts(dados))
                    setIsLoading(false)
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
    };

    const handleOpenForm = (data) => {
        const hasKit = data?.kit_number
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 200);
        if (hasKit) {
            setFormType('Editando')
            setDataToEdit(data)
            setCaseType(data?.kit_case_model || '');
        } else {
            setFormType('Criando')
            setDataToEdit({})
            setCaseType('');
        }
        setOpenForm(!openForm)
        if (!openForm) {
            if (productsData?.length === 0) {
                console.log('consumir os produtos da API')
                getProductsData()
            }
        }
    }
    const handleCancel = () => {
        const confirmed = window.confirm("Tem certeza que deseja Voltar??");
        if (confirmed) {
            setOpenForm(false)
            setIsLoading(true)
            setTimeout(() => {
                setIsLoading(false)
            }, 200);
        }
    }

    const handleClearForm = () => {
        const confirmed = window.confirm("Tem certeza que deseja limpar o formulário??");
        if (confirmed) {
            setValuesToSave([]);
        }
    };


    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const updateKit = async (params, updatedKit) => {
        setIsSavingData(true)
        const newParams = { ...params, updatedKit, paymentData: dataCheckPayment }
        console.log('new params', newParams)
        const kitProducts = JSON.stringify(newParams)
        try {
            const res = await djangoApi
                .put("products/register_prods/update_kit_seller/", kitProducts, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            const { dados, kitNumber, failed_products } = res.data

            const updatedFailureToPay = newParams?.updatedKit?.failure_to_pay
            dispatch(updateSellersKitsIsFailureChanged(dataToEdit, seller, updatedFailureToPay, newParams?.paymentData))
            setIsSavingData(false)
            const objToReturn = {
                status: res.status,
                number: kitNumber
            }
            return objToReturn
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsSavingData(false)
        } finally {
            // pass
            setIsSavingData(false)
        }
    };

    const saveKit = async (params) => {
        setIsSavingData(true)
        const newParams = { ...params, userManager: user }
        const kitProducts = JSON.stringify(newParams)
        try {
            const res = await djangoApi
                .post("products/register_prods/save_kit_seller/", kitProducts, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            const { dados, kitNumber, failed_products } = res.data
            console.log('dados: ', dados)
            console.log('data', res.status)
            console.log('produtos nao salvos', failed_products)

            setIsSavingData(false)
            const objToReturn = {
                status: res.status,
                number: kitNumber
            }
            return objToReturn
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsSavingData(false)
        } finally {
            // pass
            setIsSavingData(false)
        }
    };

    const getKits = async () => {
        setIsLoadingKit(true)
        try {
            const res = await djangoApi
                .get(`products/register_prods/${seller.id}/get_kit_seller_beta_version/`, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            const { dados, kitNumber } = res.data
            const objToSave = {
                user: seller,
                kits: dados
            }
            dispatch(setSellersKits(objToSave))
            setIsLoadingKit(false)
            const objToReturn = {
                status: res.status,
                number: kitNumber
            }
            return objToReturn
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoadingKit(false)
        } finally {
            // pass
            setIsLoadingKit(false)
        }
    };

    const handleSaveForm = async (submitType) => {
        const isCreatingFlow =
            submitType === 'Criando' ||
            submitType === 'FinalizandoECriando';

        if (isCreatingFlow && !caseType) {
            MySwal.fire(
                "Atenção",
                "Selecione o tipo de maleta antes de criar o kit.",
                "warning"
            );
            return;
        }

        const formDate = formatDate(initialDate)
        const quantNewValues = valuesToSave.filter(produto => {
            const naoVendido = !produto?.sold_prod; // undefined ou false → não vendido
            const naoDevolvido = !produto?.devolvido; // false → não devolvido
            const naoVendidoDb = !produto?.sold_prod_db
            return naoVendido && naoDevolvido && naoVendidoDb;
        })?.length

        const dataToSend = {
            user: seller,
            'prds': valuesToSave,
            payDate: formDate,
            caseType: caseType
        }
        const userName = user?.displayName
            ? user.displayName.split(' ')[0].charAt(0).toUpperCase() + user.displayName.split(' ')[0].slice(1).toLowerCase()
            : '';
        console.log('Sending Data: ', dataToSend)
        if (submitType === 'FinalizandoECriando') {
            console.log('encerrando e abrindo logic')
            const confirmResult = await MySwal.fire({
                title: `Atenção ${userName} !`,
                html: `
                    O kit será finalizado e um novo será aberto com todos os produtos que não foram 
                    <strong>VENDIDOS</strong> nem <strong>RETORNADOS</strong>. 
                    <br><br>
                    <span>Será criado um novo Kit com <strong>${quantNewValues} Produto${quantNewValues > 1 ? 's' : ''} </strong>!! </span> 
                    <br><br>
                    <small style="color: red;font-weight: bold;">Esta ação é irreversível!</small>
                `,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, continuar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            });
            if (confirmResult.isConfirmed) {
                // primeiro duplica a logica de ENCERRAR a maleta
                handleMakeInactiveKit()
                const updatedKitObj = { ...updatedKit, is_active: false };


                MySwal.fire({
                    title: 'Finalizando o Kit...',
                    html: 'Aguarde enquanto processamos o encerramento.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        MySwal.showLoading();
                    }
                });
                const newProds = valuesToSave.map(produto => {
                    if (!produto.sold_prod && !produto.sold_prod_db) {
                        return {
                            ...produto,
                            devolvido: true
                        };
                    }
                    return produto;
                });
                const newDataToSend = {
                    user: seller,
                    'prds': newProds,
                    payDate: formDate,
                    caseType: caseType
                }
                const data = await updateKit(newDataToSend, updatedKitObj)
                if (data.status === 200) {
                    console.log('Kit encerrado ');
                    // depois duplica a logica de CRIAR a maleta
                    const newPayDate = new Date(new Date().setDate(new Date().getDate() + 30))
                        .toISOString().split('T')[0];
                    const { prds } = dataToSend
                    const onlyAvailableProds = prds.filter(produto => {
                        const naoVendido = !produto.sold_prod; // undefined ou false → não vendido
                        const naoDevolvido = !produto.devolvido; // false → não devolvido
                        const naoVendidoDb = !produto.sold_prod_db
                        return naoVendido && naoDevolvido && naoVendidoDb;
                    });
                    const newDataToSend = {
                        user: seller,
                        'prds': onlyAvailableProds,
                        payDate: newPayDate,
                        caseType: caseType
                    }
                    // Atualiza o Swal para criar o novo kit
                    MySwal.update({
                        title: 'Abrindo o novo Kit...',
                        html: 'Estamos criando o novo kit com produtos disponíveis.',
                        showConfirmButton: false,   // mantém sem botão
                        allowOutsideClick: false    // não permite clicar fora
                    });

                    // Reativa o spinner
                    MySwal.showLoading();

                    console.log('newObjtoSendOnlyAvaiable: ', newDataToSend)
                    const newData = await saveKit(newDataToSend)
                    if (newData.status === 201) {
                        MySwal.fire("Feito", `Kit Número ${newData?.number} Gerado com Sucesso!!`, "success").then(() => {
                            // Code to execute after the alert is confirmed
                            // For example, redirect to another page or refresh data
                            setValuesToSave([])
                            setOpenForm(false)
                            getKits()
                        })
                    }
                }
            } else {
                console.log('Usuário cancelou a operação');
            }
        }


        if (submitType === 'Criando') {
            console.log('criando logic')
            const data = await saveKit(dataToSend)
            if (data.status === 201) {
                MySwal.fire("Feito", `Kit Número ${data?.number} Gerado com Sucesso!!`, "success").then(() => {
                    // Code to execute after the alert is confirmed
                    // For example, redirect to another page or refresh data
                    setValuesToSave([])
                    setOpenForm(false)
                    getKits()
                })
            }
            setIsSavingData(false)
        } else if (submitType === 'Editando') {
            console.log('editando logic')
            const data = await updateKit(dataToSend, updatedKit)
            if (data.status === 200) {
                MySwal.fire("Feito", `Kit Número ${data?.number} Alterado com sucesso!!`, "success").then(() => {
                    // Code to execute after the alert is confirmed
                    // For example, redirect to another page or refresh data
                    setValuesToSave([])
                    setOpenForm(false)
                    getKits()
                })
            }
            setIsSavingData(false)
        }
    }



    useEffect(() => {
        const getKits = async () => {
            setIsLoadingKit(true)
            try {
                const res = await djangoApi
                    .get(`products/register_prods/${seller.id}/get_kit_seller_beta_version/`, {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    })
                const { dados, kitNumber } = res.data
                const objToSave = {
                    user: seller,
                    kits: dados
                }
                dispatch(setSellersKits(objToSave))
                setIsLoadingKit(false)
                const objToReturn = {
                    status: res.status,
                    number: kitNumber
                }
                return objToReturn
            } catch (err) {
                console.log("Erro ao alterar as aplicações", err);
                window.alert(err);
                setIsLoadingKit(false)
            } finally {
                // pass
                setIsLoadingKit(false)
            }
        };
        getKits()
    }, []);




    const handlerOpenShowModal = (data) => {
        setShowModalprods(data)
        setOpen(true)
    }

    const handleOpenPromiModal = (data) => {
        seTdataPromiss(data)
        setOpenNotaPromi(true)
    }

    const handleChangeActive = () => {
        setIsDirty(true)
        setUpdatedKit((prev) => {
            // Create a new array to avoid mutating state directly
            const newValues = {
                ...prev,
                is_active: isActiveKit
            }
            return newValues;
        });
        setIsActiveKit(!isActiveKit)
    }

    const handleMakeInactiveKit = () => {
        setUpdatedKit((prev) => {
            // Create a new array to avoid mutating state directly
            const newValues = {
                ...prev,
                is_active: false
            }
            return newValues;
        });
        setIsActiveKit(true)
    }

    const handleChangeFailure = () => {
        setIsDirty(true)
        setUpdatedKit((prev) => {
            // Create a new array to avoid mutating state directly
            const newValues = {
                ...prev,
                failure_to_pay: !failureToPay
            }
            return newValues;
        });
        setFailureToPay(!failureToPay)
    }

    return (
        <>
            <ShowProductsPage open={open} setOpen={setOpen} products={showModalprods} sellersData={sellersKits} />
            <NotaPromiPage open={openNotaPromi} setOpen={setOpenNotaPromi} data={dataPromiss} />
            {
                !openForm &&
                <Grid container direction={"row"} gap={1} justifyContent={"space-between"} marginBottom={"20px"}>
                    {
                        dataToGrid.map((data, i) => {
                            return (
                                <Grid item xs={12} sm={6} md={1.6} key={i}>
                                    <Paper
                                        elevation={6}
                                        sx={{
                                            backgroundColor: colors.pink[800]
                                            // backgroundColor: theme.palette.mode === "light" && colors.primary[900]
                                        }}
                                    >
                                        <CardContent sx={{ paddingBottom: "16px !important" }}>
                                            <Typography variant="h6" fontWeight={"bold"}>
                                                {data.title}
                                            </Typography>
                                            <Typography variant="body1">{data.value}</Typography>
                                        </CardContent>
                                    </Paper>
                                </Grid>
                            )
                        })
                    }

                </Grid>
            }
            <Box
                sx={{
                    margin: openForm ? '10px 0px' : '20px 0px',
                    gap: '20px',
                    display: 'flex',
                    width: '100%',
                    justifyContent: !openForm ? 'flex-end' : 'flex-start'
                }}
            >
            </Box>
            {
                openForm ?
                    <>
                        <Box
                            sx={{
                                marginBottom: '10px'
                            }}
                        >
                            <ResumeInfoBox sellerInfo={seller} avgKitValues={avgKitValues} />
                        </Box>
                        <FormKitPage
                            isLoading={isLoading}
                            setValuesToSave={setValuesToSave}
                            valuesToSave={valuesToSave}
                            initialDate={initialDate}
                            setInitialDate={setInitialDate}
                            formType={formType}
                            dataToEdit={dataToEdit}
                            handleChangeActive={handleChangeActive}
                            isActiveKit={isActiveKit}
                            setIsActiveKit={setIsActiveKit}
                            sellersKits={sellersKits}
                            setUpdatedKit={setUpdatedKit}
                            setValueForResume={setValueForResume}
                            setValueForComission={setValueForComission}
                            setValueForComissionVeludos={setValueForComissionVeludos}
                            setValueForComissionSacolas={setValueForComissionSacolas}
                            handleChangeFailure={handleChangeFailure}
                            failureToPay={failureToPay}
                            setFailureToPay={setFailureToPay}
                            caseType={caseType}
                            setCaseType={setCaseType}
                            setIsDirty={setIsDirty}

                        />
                        <Box
                            sx={{
                                marginTop: '10px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: 'row'
                            }}
                        >
                            <Box>
                                <Button color='warning' variant='contained' sx={{ color: 'white' }}
                                    startIcon={<KeyboardDoubleArrowLeftIcon />}
                                    onClick={handleCancel}
                                >
                                    Cancelar
                                </Button>
                            </Box>
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                gap={"20px"}
                            >
                                {formType === 'Criando' &&
                                    <Button color='warning' variant='contained' sx={{ color: 'white' }}
                                        startIcon={<DeleteIcon />}
                                        onClick={handleClearForm}
                                        disabled={valuesToSave?.length === 0}
                                    >
                                        Limpar
                                    </Button>
                                }
                                {
                                    formType !== 'Criando' &&

                                    <LoadingButton
                                        disabled={valuesToSave?.length === 0 || formType === 'Edit00ando' || valuesToSave.filter(produto => {
                                            const naoVendido = !produto?.sold_prod; // undefined ou false → não vendido
                                            const naoDevolvido = !produto?.devolvido; // false → não devolvido
                                            const naoVendidoDb = !produto?.sold_prod_db
                                            return naoVendido && naoDevolvido && naoVendidoDb;
                                        }).length === 0}

                                        loading={isSavingData}
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                        onClick={() => handleSaveForm('FinalizandoECriando')}
                                        color='warning'
                                        sx={{ color: 'white' }}
                                    >
                                        Finalizar e Gerar Outro
                                    </LoadingButton>
                                }
                                <LoadingButton
                                    disabled={
                                        valuesToSave?.length === 0 ||
                                        formType === 'Edit00ando' ||
                                        !isDirty ||
                                        isCreatingKitWithoutCase
                                    }
                                    loading={isSavingData}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    onClick={() => handleSaveForm(formType)}
                                    color={formType === 'Criando' ? 'success' : 'info'}
                                    sx={{ color: 'white' }}
                                >
                                    {formType === 'Criando' ? 'Confirmar' : 'Editar'}
                                </LoadingButton>
                            </Box>
                        </Box>
                        <Box width={"100%"} mt={4} mb={2}>
                            <Divider variant='fullWidth' />
                        </Box>
                        <Box>
                            <ObservacaoKitPage observacao='teste de observaçoes' kitData={dataToEdit} seller={seller} />
                        </Box>
                        <Box width={"100%"} mt={4} mb={2}>
                            <Divider variant='fullWidth' />
                        </Box>
                        <Box mt={2} >
                            <ResumeSectionKit
                                formType={formType}
                                dataToEdit={dataToEdit}
                                totalSoldProdsValue={valueForResume}
                                valueForComission={valueForComission}
                                valueForComissionVeludos={valueForComissionVeludos}
                                valueForComissionSacolas={valueForComissionSacolas}
                                dataToShow={paymentToPitaya}
                                setDataToShow={setPaymentToPitaya}
                                seller={seller}
                                setDataCheckPayment={setDataCheckPayment}
                            />
                        </Box>
                        <Box width={"100%"} mt={4} mb={2}>
                            <Divider variant='fullWidth' />
                        </Box>
                        <Box width={"100%"} mt={1} mb={2}
                            height={(nfExist || nfExistProd) && "100%"}
                        >
                            <CreateNf data={dataToEdit} sellerData={seller}
                                paymentToPitaya={paymentToPitaya}
                                nfExist={nfExist}
                                setNfExist={setNfExist}
                                nfExistProd={nfExistProd}
                                setNfExistProd={setNfExistProd}
                            />
                        </Box>
                    </>

                    :
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                        }}
                    >
                        <Paper elevation={8} sx={{ minHeight: "calc(100vh - 240px)", backgroundColor: colors.pink[900] }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    // flexDirection: 'row',
                                    width: '100%',
                                    padding: '10px 20px',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <CardHeader title="Kits" sx={{ fontWeight: 'bold' }} />
                                {
                                    !openForm &&



                                    <Button color='success' size="small" variant='contained' disabled={seller.firebase_disabled || (isLoadingKit || isLoading)} sx={{ color: 'white', width: '80px', height: '35px' }}
                                        startIcon={<AddCircleOutlineIcon />}
                                        onClick={handleOpenForm}
                                    >
                                        Kit
                                    </Button>
                                }
                            </Box>
                            <CardContent sx={{ height: '100%' }}>
                                {
                                    (isLoadingKit || isLoading) &&
                                    <KitTableSkeleton />
                                }
                                {
                                    !isLoading && !isLoadingKit &&
                                    <Box
                                        mt={2}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 1,
                                            marginBottom: 1,
                                        }}
                                    >
                                        <SellerSoldProductsAccordion
                                            seller={seller}
                                            theme={theme}
                                            colors={colors}
                                            subtleBorder={`1px solid rgba(0,0,0,0.08)`}
                                            softText={theme.palette.mode === "dark" ? colors.grey[200] : "text.secondary"}
                                        />
                                        <SellerWarrantiesAccordion
                                            seller={seller}
                                            theme={theme}
                                            colors={colors}
                                            subtleBorder={`1px solid rgba(0,0,0,0.08)`}
                                            softText={theme.palette.mode === "dark" ? colors.grey[200] : "text.secondary"}
                                        />

                                        <SellerKitOrdersAccordion
                                            seller={seller}
                                            theme={theme}
                                            colors={colors}
                                            subtleBorder={`1px solid rgba(0,0,0,0.08)`}
                                            softText={theme.palette.mode === "dark" ? colors.grey[200] : "text.secondary"}
                                        />
                                    </Box>
                                }

                                {sellersKits?.kits?.length > 0 && !isLoading && !isLoadingKit &&
                                    <TablesKitPage sellersData={sellersKits} handlerEditProduct={handleOpenForm} setOpen={handlerOpenShowModal}
                                        setOpenNotaPromi={handleOpenPromiModal}
                                        formType={formType}
                                    />
                                }
                                {
                                    sellersKits?.kits?.length === 0 && !isLoading && !isLoadingKit &&
                                    <Box
                                        display={'flex'}
                                        justifyContent={"center"}
                                        alignItems={"center"}
                                        height={"420px"}
                                    >
                                        <Typography color={colors.primary[100]} variant="h4">
                                            SEM KITS CADASTRADOS
                                        </Typography>
                                    </Box>
                                }
                            </CardContent>
                        </Paper>
                    </Box>
            }
        </>

    );
}

export default DataSectionSeller;